import { createContext, useContext, useState } from "react";

const RelaseNoteContext = createContext();

export const GlobalreleaseProvider = ({ children }) => {
  const [releaseNotes, setReleaseNotes] = useState(false);
  return (
    <RelaseNoteContext.Provider value={{ releaseNotes, setReleaseNotes }}>
      {children}
    </RelaseNoteContext.Provider>
  );
};


export const useReleaseContext=()=>useContext(RelaseNoteContext)